import { useState } from "react";
import styles from "./ImageWithPlaceholder.module.css"; // create this CSS file

export default function ImageWithPlaceholder({ src, alt }) {
    const [loaded, setLoaded] = useState(false);

    return (
        <div className={styles.wrapper}>
            {!loaded && <div className={styles.placeholder} />}
            <img
                src={src}
                alt={alt}
                className={`${styles.image} ${loaded ? styles.show : styles.hide}`}
                onLoad={() => setLoaded(true)}
                loading="lazy"
            />
        </div>
    );
}
